import React from 'react';
import {AccentedSvgIcon, AccentedSvgIconProps} from './AccentedSvgIcon';

export const ArrowLeft = (props: AccentedSvgIconProps): JSX.Element => (
    <AccentedSvgIcon {...props} className="ue-icon-arrow-left arrow">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2925 1.20749L0.548728 10.9513L10.2925 20.6951L11.5917 19.3959L4.06572 11.8699L19.7826 11.8699L19.7826 10.0326L4.06572 10.0326L11.5917 2.50666L10.2925 1.20749Z"
        />
    </AccentedSvgIcon>
);
